import DeleteButton from 'CMFW/button/DeleteButton';
import NewButton from 'CMFW/button/NewButton';
import ReloadButton from 'CMFW/button/ReloadButton';
import SaveButton from 'CMFW/button/SaveButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import {
  ContainerLeft,
  ContainerLeftFooter,
  ContainerRight,
  EditorRow,
  ModuleContainer,
} from 'components/common/styles';
import { PanelIntroSelect } from 'components/selects/PanelIntroSelect';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import KLineModel from 'models/KLineModel';
import Note from 'modules/Note/Note';
import React, { useMemo } from 'react';
import Translations from '../../components/translation/Translations';
import styled from 'styled-components';

export type IProps = {
  courseId: number;
};

const KLine: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();

  const kLineModel = useMemo(() => new KLineModel({ render: forceRender, courseId: props.courseId }), [
    forceRender,
    props.courseId,
  ]);

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={kLineModel}>
        <Split widthLeft={540}>
          <ContainerLeft>
            <Grid />
            <ContainerLeftFooter>
              <ReloadButton />
              <NewButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <EditorRow>
                <PanelIntroSelect />
                <SaveButton />
              </EditorRow>
              <Scroll>
                <Translations keyName={'sources'} refId={kLineModel.ref} />
              </Scroll>
              <DeleteButton />
            </ItemLayout>
            <Note />
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default KLine;

const Scroll = styled.div`
  flex-grow: 1;
  overflow: auto;
  padding-bottom: 10px;
  padding-right: 10px;
`;
